export default {
  required: "{0}を入力してください。",
  requiredCommon: "空にすることはできません。",
  errorFormat: "{0}の入力形式が正しくありません。",
  objectNotFound: "オブジェクトが見つかりません。",
  noDataAvailable:
    "検索条件に該当するデータが見つかりません。検索条件を見直してください。",
  noData: "データなし",
  loadingData: "データを読み込み中、少々お待ちください...",
  sessionExpired:
    "セクションがタイムアウトしました。再度ログインしてください。",
  errorSystem: "システムエラーが発生しました。もう一度確認してください。",
  inputExcludedHtml:
    "この項目にHTMLコード及びスクリプトコードを入力しないでください。",
  sizeInputBetween: "{0}は{1}~{2}文字列で入力してください。",
  passwordInputBetween: "新パスワード設定は{1}~{2}文字列で入力してください。",
  internetConnectionRestore: "インターネット接続が復元されました。",
  noInternet:
    "サーバへ接続ができません。インターネット接続を確認してください。",
  isNumberRequire: "値は数値でなければなりません",
  save: "保存",
  add: "add new",
  cancel: "キャンセル",
  update: "update",
  require: "必須",
  valueMustLessThan: "Value must <= {0}",
  totalMustEqual: "Total must = {0}",
  totalWeightBiggerThan70: "total weight cannot > 70",
  notBlank: "必須",
  maxChar: "{0}文字以内で入力してください。",
  mustNumPositive: "0より大きい数字で入力してください。",
  createSuccess: "登録完了",
  createFail: "登録失敗",
  updateSuccess: "更新完了",
  updateFail: "更新失敗",
  deleteSucceed: "削除完了",
  integer: "正の整数で入力してください。",
  decimal: "正の少数で入力してください。",
  sendMailSuccess: "Mail reset password has been sent",
  resetPassSuccess: "パスワードがリセットされた。",
  confirmResetPass: "パスワード情報をリセットしますか?",
  confirmReadInstruction:
    "試験を開始する前に、必ずコンテンツを確認してください。",
  resetPassOnRandomSucceed:
    "パスワードがリセットされた。<br />新しいパスワード:「<b>{0}</b>」。",
  notSamePass: "確認パスワードが一致しません。",
  overFileSize: "ファイルの容量は%{0}MBを超えています。",
  wrongFileExtension: "Doc、Docx形式ファイルをアップロードしてください。",
  wrongInstructionFileExtension: "PDF形式ファイルをアップロードしてください。",
  fileNameFormatTooLong: "ファイル名の形式が長すぎます。",
  least1CorrectAnswer: "少なくとも1つの正解",
  numberRequired: "半角英数字で入力してください。",
  mustIntegerNumber: "整数で入力してください。",
  numberLimit: "は{0}文字以内で入力してください。",
  valueMustGreaterThan: "値はゼロより大きくなければなりません。",
  valueMustNotNegative: "値は負数なりません。",
  numberQuestionsOnExamCategoryEmpty: "問題の数は空です。 カテゴリが無効です。",
  numberQuestionsGreaterThanRequiredQuestions:
    "問題件数が最小問題件数より小さいくなっています。最小問題件数は{0}件です。",
  numberQuestionsOnExamCategoryIsNotValid:
    "問題件数が問題リストの問題数へ超えました。最大問題件数は{0}件です。",
  passingScoreOnTargetIsNotValid:
    "合計合格ラインは各合格ラインの合計以上、問題件数合計以下で設定してください。",
  passingScoreOnProblemIsNotValid:
    "合計ラインは問題点数の合計以下で設定してください。",
  questionRelationNotCoincideItself: "先行問題は本問題で設定できません。",
  questionRelationIsNumber: "先行問題は数値で入力してください。",
  questionRelationMustBeLessThanTotal: "先行問題は存在していません。",
  questionRelationMustBeSameCategory:
    "先行問題は同じカテゴリでの問題で設定してください。",
};
